<template>
  <div class="activeDetail active">
    <van-cell-group class=" info">
      <van-cell title="活动名称">
        <p class="item2"> {{campaign.Name}}</p>
      </van-cell>
      <van-cell title="活动日期">
        <p class="item2">{{(campaign.U_RangeTime || "").replace(/-/g,'/').replace(',','-')}}</p>
      </van-cell>
      <van-cell title="活动地点">
        <p class="item2"> {{campaign.U_CampPlace}}</p>
      </van-cell>
      <van-cell title="邀请人数">
        <p class="item2"> {{campaign.U_InvitedCnt}}</p>
      </van-cell>
      <van-cell title="集客目标">
        <p class="item2"> {{campaign.U_FansTarget}}</p>
      </van-cell>
      <van-cell title="销售目标">
        <p class="item2"> {{campaign.U_SaleTarget}}</p>
      </van-cell>
      <van-cell title="讲师姓名">
        <p class="item2"> {{campaign.U_TeacherName}}</p>
      </van-cell>
      <van-cell title="合作伙伴">
        <p class="item2"> {{campaign.U_Partner}}</p>
      </van-cell>
      <van-cell title="活动类型">
        <p class="item2"> {{campaign.campTypeName}}</p>
      </van-cell>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell title="活动主题" @click="showZhuti=!showZhuti">
       <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" />
      </van-cell>
        <div class="cell-content" v-if="showZhuti" v-html="campaign.U_Theme">
        </div>
      </van-cell>
    </van-cell-group>
    <van-cell-group class="group">
      <van-cell title="活动目的" >
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showMudi=!showMudi"/>
      </van-cell>
      <div class="cell-content" v-if="showMudi" v-html="campaign.U_Purpose">
      </div>
      </van-cell>
    </van-cell-group>
    <van-cell-group class="group">
      <van-cell title="讲师介绍" >
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showJieshao=!showJieshao"/>
      </van-cell>
      <div class="cell-content" v-if="showJieshao" v-html="campaign.U_Instructor">
      </div>
      </van-cell>
    </van-cell-group>
    <van-cell-group class="group">
      <van-cell title="场地介绍" >
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showChangdi=!showChangdi"/>
      </van-cell>
      <div class="cell-content" v-if="showChangdi" v-html="campaign.U_Venue">
      </div>
      </van-cell>
    </van-cell-group>

    <van-cell-group class="group group-table">
      <van-cell title="流程介绍" >
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px"  @click="showLiucheng=!showLiucheng"/>
      </van-cell>

      <div class="table van-hairline--surround" v-if="showLiucheng">
        <div class="table-title flex ">
          <p class="item1">序号</p>
          <p class="item2">日期</p>
          <p class="item2">时间</p>
          <p class="item3">内容</p>
        </div>
        <template v-for="(item,index) in processList">
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">{{index+1}}</li>
            <li class="item2 van-hairline--right">{{item.U_Flow|getActiveDate}}</li>
            <li class="item2 van-hairline--right">{{item.U_Flow|getActiveTime}}</li>
            <li class="item3 flex-column">
              <span class="item1 content common-limit-2">{{item.U_Details}}</span>
            </li>
          </ul>
        </template>
      </div>
    </van-cell-group>

    <van-cell-group class="group group-table">
      <van-cell   >
        <template slot="title">
          <span class="custom-text">活动预算</span>
          <span class="mini-text">（未税{{$numeral((totalBudget.amount||0).toFixed(2)).format('0,0.00')}}，含税{{$numeral((totalBudget.unamount||0).toFixed(2)).format('0,0.00')}}）</span>
        </template>
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showYusuan=!showYusuan"/>
      </van-cell>
      <div class="table van-hairline--surround" v-if="showYusuan">
        <div class="table-title flex ">
          <p class="item1">序号</p>
          <p class="item2">名称</p>
          <p class="item1">数量</p>
          <p class="item3">未税费用</p>
          <p class="item3">含税费用</p>
        </div>

        <template v-for="(item,index) in budgetList">
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">{{index+1}}</li>
            <li class="item2 van-hairline--right">{{item.Name}}</li>
            <li class="item1 van-hairline--right">{{$numeral(item.U_Qty).format('0,0')}}</li>
            <li class="item3 van-hairline--right">{{$numeral(item.U_Amount).format('0,0.00')}}</li>
            <li class="item3 flex">
              <p class="item1">{{$numeral(item.U_AmountAftTax).format('0,0')}}</p>
            </li>
          </ul>
        </template>

        <ul class="table-content flex van-hairline--top">
          <li class="item3 van-hairline--right">合计</li>
          <li class="item1 van-hairline--right">{{$numeral(totalBudget.count||0).format('0,0')}}</li>
          <li class="item3 van-hairline--right">{{$numeral((totalBudget.amount||0).toFixed(2)).format('0,0.00')}}</li>
          <li class="item3">{{$numeral((totalBudget.unamount||0).toFixed(2)).format('0,0.00')}}</li>
        </ul>
      </div>
    </van-cell-group>

    <van-cell-group class="group group-table">
      <van-cell   >
        <template slot="title">
          <span class="custom-text">物料申请</span>
          <span class="mini-text">（合计数量：{{$numeral(totalMaterial).format('0,0')}}）</span>
        </template>
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showWuliao=!showWuliao"/>
      </van-cell>
      <div class="table van-hairline--surround" v-if="showWuliao">
        <div class="table-title flex ">
          <p class="item1">序号</p>
          <p class="item3">产品一级分类</p>
          <p class="item2">产品名称</p>
          <p class="item1">数量</p>
          <p class="item3">归还日期</p>
        </div>
        <template v-for="(item,index) in materialList">
          <ul class="table-content flex van-hairline--top">
            <li class="item1 van-hairline--right">{{index+1}}</li>
            <li class="item3 van-hairline--right">{{item.U_MaterialClass}}</li>
            <li class="item2 van-hairline--right">{{item.Name}}</li>
            <li class="item1 van-hairline--right">{{$numeral(item.U_Qty).format('0,0')}}</li>
            <li class="item3 flex">
              <p class="item1">{{item.U_ReturnDate}}</p>
            </li>
          </ul>
        </template>
      </div>
    </van-cell-group>

    <van-cell-group class="group" v-if="showWuliao">
      <van-cell title="图片"  />  </van-cell>
      <div class="clear">
        <template v-for="(item,index) in materialImgList">
          <p class="upload-img fl">
            <img :src="$config.serverURL+'upload/'+item.U_url" @click="previewList(materialImgList,index)">
          </p>
        </template>
      </div>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell title="审批记录" >
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showShenpi=!showShenpi"/>
      </van-cell>
      <ul class="steps" v-if="showShenpi">
        <template v-for="item in flowRecordList">
          <li class="step">
            <van-icon v-if="item.approvalFlow&&item.approvalFlow.U_Status=='N'" name="clear" class="step-icon" color="#e83c39"  size="20px"/>
            <van-icon v-else-if="item.approvalFlow&&item.approvalFlow.U_Status=='Y'" name="checked" class="step-icon"  color="#02c316"  size="20px"/>
            <van-icon v-else name="play-circle"  class="step-icon" color="#8bc34a"  size="20px"/>
            <p>
              <p class="flex">
                <span class="item1">{{item.approvalFlow.createTime}}</span>
                <span class="item1">{{item.approvalFlow.salesName}}</span>
              </p>
              <p v-if="item.approvalFlow&&(item.approvalFlow.U_Status=='M'|| item.approvalFlow.U_Status=='S')">提交备注：{{item.approvalFlow.U_Remark}}</p>
              <p v-if="item.approvalFlow&&item.approvalFlow.U_Status=='D'">{{item.approvalFlow.U_Remark}}</p>
              <p v-if="item.approvalFlow&&(item.approvalFlow.U_Status=='N'|| item.approvalFlow.U_Status=='Y')">审批备注：{{item.approvalFlow.U_Remark}}</p>
              <p class="clear">
                <template v-for="(img,index) in item.imgList">
                  <img :src="$config.serverURL+'upload/'+img.U_url" class="step-img fl" @click="previewList(item.imgList,index)">
                </template>
              </p>
            </p>
          </li>
        </template>
      </ul>
      <p class="text-center" v-if="showShenpi&&flowRecordList.length==0">暂无审批记录</p>
    </van-cell-group>

    <van-cell-group class="group" v-if="isApproval">
      <van-cell title="审批备注"  />
      <van-field
        class="textarea van-hairline--surround"
        type="textarea"
        placeholder="请输入备注内容描述"
        rows="3"
        autosize
        v-model="remark"
        @input="limitLength(1024,'remark')"
      />
      <div class="clear">
        <template v-for="(img,index) in imgs">
          <p class="upload-img fl">
            <img :src="$config.serverURL+'upload/'+img" alt="" @click="previewList(imgs,index)">
            <van-icon name="clear" class="del-icon" color="#e83c39"  size="20px" @click="delImg(index)"/>
          </p>
        </template>
        <van-uploader  class="upload fl" :after-read="afterRead" multiple>
          <van-icon name="plus" />
          <p>上传图片</p>
        </van-uploader>
      </div>
    </van-cell-group>

    <van-cell-group class="group" multiple>
      <van-cell title="活动签到二维码"  />

      <div class="qrcode">
        <img :src='qrCode' @click="previewQr(qrCode)"/>
      </div>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell >
        <template slot="title">
          <span class="custom-text">参与成员</span>
          <span class="mini-text c-red">（{{total}}人）</span>
        </template>
        <van-icon slot="right-icon" name="arrow-down" class="custom-icon" size="20px" @click="showChengyuan=!showChengyuan"/>
      </van-cell>
      <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" v-if="showChengyuan" @load="getMemberList">
        <template v-for="item in list">
          <div class="list-card" >
            <div class="flex">
              <p class="item1">姓名：{{item.custName}}</p>
              <p class="item1">性别：{{item.sexName}}</p>
            </div>
            <div class="flex">
              <p class="item1">手机号：{{item.U_Mobile}}</p>
              <p class="item1 get-work" v-if="item.U_UploadedShow" @click="seeWorks(item.U_CampMemberId)">查看作品</p>
            </div>
          </div>
        </template>
      </van-list>
    </van-cell-group>

    <div class="bottom-btn flex" v-if="isApply && hasModifyAuth">
      <div class="item1 btn save" v-if="campaign.U_ApprovalStatus=='D'||campaign.U_ApprovalStatus=='N'||(campaign.U_ApprovalStatus=='Y'&&campaign.rptCnt<=0)" @click="toReply">修改</div>
      <div class="item1 btn sub" @click="getPdf">生成pdf</div>
      <div class="item1 btn save" v-if="(campaign.U_ApprovalStatus=='W'||campaign.U_ApprovalStatus=='Y')&&campaign.rptCnt>0" @click="toReport">活动报告</div>
    </div>
    <div class="bottom-btn flex" v-else-if="isApproval">
      <div class="item1 btn save"  v-if="campaign.U_ApprovalStatus=='W' && hasAuditAuth" @click="toShenpi(submitFlag.refuse)">拒绝</div>
      <div class="item1 btn sub" v-if="campaign.U_ApprovalStatus=='W' && hasAuditAuth" @click="toShenpi(submitFlag.pass)">审批</div>
      <div class="item1 btn save" v-if="campaign.U_ApprovalStatus=='Y'&&campaign.rptCnt>0" @click="toReport">活动报告</div>
      <div class="item1 btn sub" v-if="campaign.U_ApprovalStatus=='Y' || !hasAuditAuth" @click="getPdf">生成pdf</div>
    </div>
    <div class="bottom-btn flex" v-if="!isApply&&!isApproval&&overLoad">
      <div class="item1 btn sub" @click="getPdf">生成pdf</div>
    </div>
  </div>
</template>
<script>
  import apiActive from '@/api/active'
  import moment from 'moment'
  import $config  from '@/config/config';
  import {ImagePreview} from 'vant'
  import campKit from '@/common/campKit';
  import imageCompression from 'browser-image-compression';

  export default{
    data(){
      return {
        id:'',
        campaign:{},  //基本信息
        processList:[],  //活动流程列表
        budgetList:[],  //活动预算列表
        materialList:[], //物料申请列表
        materialImgList:[], //物料申请图片列表
        flowRecordList:[], //审批记录
        memberList:[], //活动成员列表
        qrCode:'',  //活动二维码地址

        showZhuti:false,
        showMudi:false,
        showJieshao:false,
        showChangdi:false,
        showLiucheng:false,
        showYusuan:false,
        showWuliao:false,
        showShenpi:false,
        showChengyuan:false,


        //分页
        loading:false,
        finished:false,
        pageNo:1,
        pageSize:10,
        total:0,
        list:[],

        isApply:false,  //是否为活动申请人
        isApproval:false,  //是否为审批人
        overLoad:false, //详情是否请求完


        remark:'', //审批备注
        imgs:[],
        submitFlag : campKit.submitFlag, //提交标记
        menuId : '', //菜单ID
        hasModifyAuth : true, //是否有修改权限
        hasAuditAuth : true, //是否有审批权限
      }
    },
    filters: {
      getDate: function (value) {
        if (!value) return ''
        return moment(parseInt(value)).format('YYYY-MM-DD')
      },
      getTime: function (value) {
        if (!value) return ''
        return moment(parseInt(value)).format('HH:mm:ss')
      },
      getActiveDate: function (value) {
        if (!value||!value.split(' ')) return ''
        if(value.split(' ').length<=1) return ''
        return value.split(' ')[0]
      },
      getActiveTime: function (value) {
        if (!value||!value.split(' ')) return ''
        if(value.split(' ').length<=1) return ''
        return value.split(' ')[1]
      }
    },
    computed:{
      totalBudget(){//活动预算合计
          let count= 0,amont = 0, unamont = 0
          for( var item of this.budgetList){
            count +=parseInt(item.U_Qty||0)
            amont +=parseInt(item.U_Amount*100)/100
            unamont +=parseInt(item.U_AmountAftTax*100)/100
          }
          let data= {
            count:count, amount:amont, unamount:unamont
          }
          return data
       },
      imgUrl(){ //图片地址
        let str = ''
        if(this.imgs.length>99){
          this.$title('最多不能超过99张')
          return
        }
        for(var key in  this.imgs){
            if(key<this.imgs.length-1){
              str+=this.imgs[key]+','
            }else{
              str+=this.imgs[key]
            }
        }
         return str
      },
      totalMaterial(){//物料合计
        let count= 0
        for( var item of this.materialList){
          count +=parseInt(item.U_Qty||0)
        }
        return count
      },
    },
    watch:{
      'campaign.U_RangeTime':function(){

      }
    },
    methods:{
      getDetail(){
        apiActive.campaignDetail({
          salesId:this.$wxuserUtil.getUserId(),
          id:this.$route.query.id
        }).then(response=>{
          if(response.success==true){
            this.overLoad = true
            this.campaign = response.data.campaign
            this.processList = response.data.processList
            this.budgetList = response.data.budgetList
            this.materialList = response.data.materialList
            this.materialImgList = response.data.materialImgList||[]
            this.flowRecordList = response.data.flowRecordList||[]
//            this.memberList = response.data.memberList||[]
            this.qrCode=this.$api.getQrcode(this.campaign.CampaignUrl)

            this.isApply =(this.campaign.U_CreatedId==this.$wxuserUtil.getUserId())
            this.isApproval =(this.campaign.auditId==this.$wxuserUtil.getUserId())
          }else{
            this.$title(`获取活动详情失败,${response.msg}`);
          }
        })
      },
      getMemberList(){
          if(this.finished){
            return
          }
          apiActive.campaignDetailMember({
            salesId:this.$wxuserUtil.getUserId(),
            campId:this.$route.query.id,
            pageNo:this.pageNo,
            pageSize:this.pageSize
          }).then(response=>{
            this.loading = false
            if(response.success==true){
              this.list=this.list.concat(response.data.list || []);
              this.total = response.data.totalRow
              if(response.data.totalRow<=this.list.length){
                this.finished= true
              }else{
                this.pageNo=this.pageNo+1
              }
            }else{
              this.$title(`获取活动成员失败,${response.msg}`);
            }
          })
      },
      toReply(){
          this.$router.push('/active/apply?id='+this.$route.query.id)
      },
      toShenpi(type){
        if(type==2&&this.remark==''){
          this.$title('审批备注不能为空！');
          return
        }
        this.$api.$active.campaignAudit({
          salesId:this.$wxuserUtil.getUserId(),
          'pojo.campId':this.$route.query.id,
          'pojo.remark':this.remark,
          'pojo.imgUrl':this.imgUrl,
          'pojo.auditType':type
        }).then(response=>{
          var that = this;
          if(response.success==true){
              if(campKit.isPass(type)){
                this.$title('审批成功');
                setTimeout(function () {
                  that.getDetail();
                },1000);
              }else{
                that.getDetail();
              }

          }else{
            this.$title(`操作失败,${response.msg}`);
          }
        })
      },
      async afterRead(files){
        if(files.constructor === Array){
          if(files.length>99){
            this.$title('图片不能超过99张')
            return
          }
          for(var item of files){
            await this.onRead(item)
          }
        }else if(files.constructor === Object){
          this.onRead(files)
        }
      },
      async onRead(file){
        var fileSrc = file.file;

        var isImg = this.$wxuserUtil.validateIsImg(fileSrc);
        if(!isImg){
          return;
        }

       this.$toast({
          mask: true,
          message: '上传中...'
        });

        let lastFile = await imageCompression(fileSrc,this.$wxuserUtil.compressImgOptions);

        var formData = new FormData()
        formData.append('salesId',this.$wxuserUtil.getUserId())
        formData.append('file',lastFile);

        return  this.$api.uploadFile(formData).then(response=>{
            if(response.success==true){
              this.imgs.push(response.data.fileName)
            }else{
              this.$title(`图片上传失败,${response.msg}`);
            }
          })
      },
      delImg(index){
        this.imgs.splice(index,1)
      },
      getPdf(){
          this.$api.$active.campaignPdf({
            salesId:this.$wxuserUtil.getUserId(),
            campId:this.$route.query.id,
          }).then(response=>{
            if(response.success==true){
                let url = response.data
                window.location.href=this.$config.serverURL+'/upload/'+url
            }else{
              this.$title(`操作失败,${response.msg}`);
            }
          })
      },
      seeWorks(id){
         this.$router.push('/active/activeRemark?id='+id + "&menuId="+this.menuId)
      },
      previewQr(src){
        ImagePreview([
          src
        ]);
      },
      previewList(list,index){
          let imgs =[]
          for(var item of list){
              if(item.U_url){
                imgs.push(this.$config.serverURL+'upload/'+item.U_url)
              }else{
                  imgs.push(this.$config.serverURL+'upload/'+item)
              }
          }
        ImagePreview({
          images: imgs,
          startPosition: index,
        });
      },
      limitLength(len,key1,key2){
        let value = ''
        if(key2){
          value =this.$data[key1][key2]
        }else{
          value =this.$data[key1]
        }
        if(value.length>len){
          if(key2){
            this.$data[key1][key2]=value.slice(0,len)
          }else{
            this.$data[key1]=value.slice(0,len)
          }
        }
      },
      toReport(){
          this.$router.push('/active/reportDetail?id='+this.campaign.campReportId)
      }
    },
    mounted(){
      this.hasModifyAuth = this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Modified);
      this.hasAuditAuth =this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Audit);
    },
    created(){
      this.id = this.$route.query.id;
      this.menuId = this.$route.query.menuId;
      this.getDetail()
      this.getMemberList();

    }
  }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../style/pageStyle/pageView-activeDetail.less";
  .van-cell__label{
    word-break:break-all;
  }
  .activeDetail{
    padding-bottom:55px;
  }
  .step-img{
    width:50px;
    height:50px;
    border-radius: 5px;
    margin:5px;
  }
  .steps{
    margin:10px 15px;
    .step{
      padding:10px 15px;
      position: relative;
      .step-icon{
        position: absolute;
        top:10px;
        left:-10px;
        z-index: 2;
      }
    }
    .step:not(:last-child):after{
      content:'';
      position: absolute;
      left:0px;
      width:0;
      height:100%;
      top:15px;
      border-left:1px solid #f2f2f2;
    }

  }
 .qrcode{
   text-align: center;
   img{
     width:60%;
   }
 }
  .list-card{
    margin:20px 10px;
    background-color: #fff;
    padding:10px;
    position:relative;
    border:1px solid #f2f2f2;
    border-radius: 20px;
  }
  .get-work{
    color:#ffa014;
  }
  .group{
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/active/activeDetail.vue